// React
import { CSSProperties, ReactElement } from 'react';
// Design System
import { MyTableRowProps } from './MyTableRow';
// Utils
import { rem } from '@utmb/utils/font';
// Styles
import styles from './my-table.module.scss';

interface MyTableHeaderProps extends MyTableRowProps {}

export const MyTableHeader = (props: MyTableHeaderProps): ReactElement => {
    const { children, height, className } = props;

    // Define the CSS properties
    const style: CSSProperties = {};

    if (height) style.minHeight = rem(height);

    // Define the CSS classes
    const classesCSS = [className, styles.header].filter(Boolean).join(' ');

    return (
        <div className={classesCSS} style={style}>
            {children}
        </div>
    );
};
